"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorDatetime = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_markdown_1 = require("@opsbase/react-markdown");
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const react_1 = __importStar(require("react"));
exports.QuestionEditorDatetime = react_1.default.memo((props) => {
    const { config, onChange, disabled } = props;
    const onlyOneSelected = !(config.isDateRequired && config.isTimeRequired);
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    (0, react_1.useEffect)(() => {
        if (state !== config)
            onChange(state);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    const handleChangeIsDateRequired = (0, react_1.useCallback)(value => dispatch({ field: 'isDateRequired', value }), []);
    const handleChangeIsTimeRequired = (0, react_1.useCallback)(value => dispatch({ field: 'isTimeRequired', value }), []);
    const handleChangePreventFutureDate = (0, react_1.useCallback)(value => dispatch({ field: 'preventFutureDate', value }), []);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Checkbox_1.default, { disabled: disabled || (onlyOneSelected && config.isDateRequired), checked: state.isDateRequired, color: lib_palette_1.default.secondary, onChange: handleChangeIsDateRequired, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-datetime-date')) }),
        react_1.default.createElement(Checkbox_1.default, { disabled: disabled || (onlyOneSelected && config.isTimeRequired), checked: state.isTimeRequired, color: lib_palette_1.default.secondary, onChange: handleChangeIsTimeRequired, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-datetime-time')) }),
        react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: state.preventFutureDate, color: lib_palette_1.default.secondary, onChange: handleChangePreventFutureDate, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('prevent-future-date')) })));
});
exports.default = exports.QuestionEditorDatetime;
